import { render } from "./AppointmentTrackList.vue?vue&type=template&id=c2f68354&scoped=true"
import script from "./AppointmentTrackList.vue?vue&type=script&lang=js"
export * from "./AppointmentTrackList.vue?vue&type=script&lang=js"

import "./AppointmentTrackList.vue?vue&type=style&index=0&id=c2f68354&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f68354"]])

export default __exports__